import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

export const GeckoAlertModel = {
  type: PropTypes.oneOf([
    GECKO_CONSTS.ALERT_TYPE_DANGER,
    GECKO_CONSTS.ALERT_TYPE_INFO,
    GECKO_CONSTS.ALERT_TYPE_SUCCESS,
    GECKO_CONSTS.ALERT_TYPE_WARNING,
  ]),
  'aria-live': PropTypes.oneOf[('assertive', 'polite', 'off')],
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  icon: PropTypes.string,
};
